import React, {useState} from "react";
import AssetLibraryModal from "../AssetLibraryModal";
import "./DesignerPropertiesPanel.css";

import EmptyPropertiesState from "./sections/EmptyPropertiesState";
import BaseObjectInfoSection from "./sections/BaseObjectInfoSection";
import LayoutSection from "./sections/LayoutSection";
import CommonStyleSection from "./sections/CommonStyleSection";

import TextProperties from "./object-panels/TextProperties";
import ImageProperties from "./object-panels/ImageProperties";
import TagProperties from "./object-panels/TagProperties";
import ButtonProperties from "./object-panels/ButtonProperties";
import ShapeProperties from "./object-panels/ShapeProperties";

const DesignerPropertiesPanel = ({
                                     selectedObject,
                                     latestTags,
                                     updateObjectFields,
                                     updateObjectStyleField,
                                     updateObjectDataField,
                                     collapsed: collapsedProp,
                                     setCollapsed: setCollapsedProp,
                                 }) => {
    const [internalCollapsed, setInternalCollapsed] = useState(false);

    const collapsed =
        typeof collapsedProp === "boolean" ? collapsedProp : internalCollapsed;

    const setCollapsed =
        typeof setCollapsedProp === "function" ? setCollapsedProp : setInternalCollapsed;

    const [libraryOpen, setLibraryOpen] = useState(false);

    if (collapsed) {
        return (
            <>
                <div className="dp-collapsed-wrap">
                    <button
                        type="button"
                        className="dp-collapse-toggle dp-collapse-toggle--collapsed"
                        onClick={() => setCollapsed(false)}
                    >
                        Properties
                    </button>
                </div>

                <AssetLibraryModal
                    open={libraryOpen}
                    onClose={() => setLibraryOpen(false)}
                    onSelect={(asset) => {
                        if (!selectedObject) return;
                        updateObjectDataField(selectedObject.id, "src", asset.file_url);
                        updateObjectDataField(selectedObject.id, "asset_id", asset.id);
                    }}
                />
            </>
        );
    }

    if (!selectedObject) {
        return (
            <>
                <div className="dp-panel dp-panel--sticky dp-panel--scrollable">
                    <div className="dp-panel-header">
                        <h3 className="dp-title">Properties</h3>

                        <button
                            type="button"
                            className="dp-collapse-toggle"
                            onClick={() => setCollapsed(true)}
                            title="Collapse panel"
                        >
                            ⟩
                        </button>
                    </div>

                    <EmptyPropertiesState/>
                </div>

                <AssetLibraryModal
                    open={libraryOpen}
                    onClose={() => setLibraryOpen(false)}
                    onSelect={(asset) => {
                        if (!selectedObject) return;
                        updateObjectDataField(selectedObject.id, "src", asset.file_url);
                        updateObjectDataField(selectedObject.id, "asset_id", asset.id);
                    }}
                />
            </>
        );
    }

    return (
        <>
            <div className="dp-panel dp-panel--sticky dp-panel--scrollable">
                <div className="dp-panel-header">
                    <h3 className="dp-title">Properties</h3>

                    <button
                        type="button"
                        className="dp-collapse-toggle"
                        onClick={() => setCollapsed(true)}
                        title="Collapse panel"
                    >
                        ⟩
                    </button>
                </div>

                <BaseObjectInfoSection
                    selectedObject={selectedObject}
                    updateObjectFields={updateObjectFields}
                />

                <LayoutSection
                    selectedObject={selectedObject}
                    updateObjectFields={updateObjectFields}
                />

                <CommonStyleSection
                    selectedObject={selectedObject}
                    updateObjectStyleField={updateObjectStyleField}
                />

                {selectedObject.type === "text" && (
                    <TextProperties
                        selectedObject={selectedObject}
                        updateObjectDataField={updateObjectDataField}
                    />
                )}

                {selectedObject.type === "image" && (
                    <ImageProperties
                        selectedObject={selectedObject}
                        updateObjectDataField={updateObjectDataField}
                        onOpenLibrary={() => setLibraryOpen(true)}
                    />
                )}

                {selectedObject.type === "tag" && (
                    <TagProperties
                        selectedObject={selectedObject}
                        latestTags={latestTags}
                        updateObjectDataField={updateObjectDataField}
                        updateObjectStyleField={updateObjectStyleField}
                    />
                )}

                {selectedObject.type === "button" && (
                    <ButtonProperties
                        selectedObject={selectedObject}
                        latestTags={latestTags}
                        updateObjectDataField={updateObjectDataField}
                    />
                )}

                {selectedObject.type === "shape" && (
                    <ShapeProperties
                        selectedObject={selectedObject}
                        updateObjectDataField={updateObjectDataField}
                        updateObjectStyleField={updateObjectStyleField}
                    />
                )}
            </div>

            <AssetLibraryModal
                open={libraryOpen}
                onClose={() => setLibraryOpen(false)}
                onSelect={(asset) => {
                    updateObjectDataField(selectedObject.id, "src", asset.file_url);
                    updateObjectDataField(selectedObject.id, "asset_id", asset.id);
                }}
            />
        </>
    );
};

export default DesignerPropertiesPanel;